export const BASE_API = "https://nodejs243.onrender.com/api/v1/";
// "http://localhost:8000/api/v1";
export const BASE_URL = "https://nodejs243.onrender.com";
// "http://localhost:8000";
//bo sung them cac key
// export const Delta = 2
// export const Search = "keyword"
